import { array, boolean, discriminatedUnion, enum as enumFactory, literal, number, record, strictObject, string, unknown } from "../../lazy-zod.js";
import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import { connectorServiceSchema } from "./connector-connections.js";
import { centerAgentConnectorActionExecutionConnectionSchema, centerAgentConnectorActionOperationStatusSchema } from "./center-agent.js";
import { openConnectorRuntimeActionListSchema } from "../runtime/openconnector-runtime.js";
//#region src/schemas/http/plugin-actions.ts
const selectedAccountSchema = centerAgentConnectorActionExecutionConnectionSchema.extend({ permission: enumFactory(["read", "write"]) });
const selection = {
	service: connectorServiceSchema,
	account: enumFactory(["personal", "shared"])
};
const pluginActionRequestSchema = strictObject({
	dispatchId: string().trim().min(1).max(256).optional(),
	action: discriminatedUnion("operation", [
		strictObject({ operation: literal("list") }),
		strictObject({
			operation: literal("actions"),
			...selection
		}),
		strictObject({
			operation: literal("execute"),
			...selection,
			actionId: string().trim().min(1).max(160),
			input: record(string(), unknown()),
			operationId: string().trim().min(1).max(256),
			confirmationToken: string().uuid().optional()
		})
	])
});
const pluginActionRpcInputSchema = strictObject({
	context: openMeldRequestContextSchema,
	expectedOrganizationId: string().trim().min(1),
	request: pluginActionRequestSchema
});
const pluginActionResponseSchema = discriminatedUnion("kind", [
	strictObject({
		kind: literal("connections"),
		connections: array(selectedAccountSchema)
	}),
	strictObject({
		kind: literal("actions"),
		connection: selectedAccountSchema,
		actions: openConnectorRuntimeActionListSchema
	}),
	strictObject({
		kind: literal("confirmation_required"),
		connection: selectedAccountSchema,
		actionId: string(),
		operationId: string(),
		confirmationToken: string().uuid(),
		expiresAtMs: number(),
		message: string()
	}),
	strictObject({
		kind: literal("execution"),
		connection: centerAgentConnectorActionExecutionConnectionSchema,
		actionId: string(),
		operationId: string(),
		status: centerAgentConnectorActionOperationStatusSchema,
		replayed: boolean(),
		data: unknown().optional(),
		error: string().optional(),
		providerExecutionId: string().nullable()
	})
]);
//#endregion
export { pluginActionRequestSchema, pluginActionResponseSchema, pluginActionRpcInputSchema };

//# sourceMappingURL=plugin-actions.js.map